module.exports = __webpack_public_path__ + "img/ccl_gallery7.eac1be79.jpg";